import * as axios from 'axios';

async function translate(text, sourceLocale = 'de', targetLocale = 'en',) {
  console.log('translate', text, sourceLocale, targetLocale);
  let translation = null;
  if (text && text.length > 0) {
    const data = {
      text: text,
      sourceLocale: sourceLocale,
      targetLocale: targetLocale,
    }
 
    // Use own service
     const url = `/checklist/translate`;
    // const url = "https://pdb.8p2-data.de/api/translate";
    //const url = "http://localhost:3000/translate";
    const response = await axios.post(url, data).catch(err => {
      console.log('Translate error', err);
      return null;
    });
    console.log('translate response', response);

    if (response && response.data && response.data.status == "success" ) {
       if (response.data.translations && response.data.translations.length > 0) {
        translation = response.data.translations[0].text
       }
    }

  }
  return translation;
}

function availableLanguages() {
  return ['de', 'en', 'fr', 'pt', 'hr'];
}

export {
  translate,
  availableLanguages,
}
